module.exports = __webpack_public_path__ + "static/media/Alegreya-Bold.52a9512b.ttf";